import { API_KEYS_PAGE_SIZE } from './constants';
import { ApiKeyStatus, ListApiKeysResponse } from './types';
import { axiosMeedioClient } from '../client';
import { dedupeInFlight } from '../inFlightDedupe';

export interface ListApiKeysParams {
  workspaceId: string;
  status?: ApiKeyStatus;
  page?: number;
  limit?: number;
}

// Emits a key-sorted query object so the dedupe key is stable regardless of
// input order, mirroring `buildListQueryParams` in `schedulingMeetingsList.ts`.
const buildApiKeysQueryParams = (params: ListApiKeysParams): Record<string, string> => {
  const queryParams: Record<string, string> = {
    page: String(params.page ?? 1),
    limit: String(params.limit ?? API_KEYS_PAGE_SIZE),
  };

  if (params.status) queryParams.status = params.status;

  return Object.fromEntries(
    Object.keys(queryParams)
      .sort()
      .map((key) => [key, queryParams[key]])
  );
};

export const listApiKeys = ({ workspaceId, status, page, limit }: ListApiKeysParams): Promise<ListApiKeysResponse> => {
  const queryParams = buildApiKeysQueryParams({ workspaceId, status, page, limit });

  // queryParams is key-sorted, so the serialized dedupe key is stable for
  // identical requests; tab re-entry and rapid sub-tab toggles collapse to one.
  const key = `apiKeys:${workspaceId}:${JSON.stringify(queryParams)}`;

  return dedupeInFlight(key, async () => {
    const { data } = await axiosMeedioClient.get<ListApiKeysResponse>(`/v1/workspaces/${workspaceId}/api-keys`, {
      params: queryParams,
    });
    return data;
  });
};
